export default theme => ({
  page: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%'
  },
  heading: {
    fontSize: 24,
    fontWeight: 600,
    color: theme.grey1,
    marginBottom: 24
  },
  orgTitle: {
    display: 'flex',
    alignItems: 'center',
    paddingBottom: 14
  },
  orgName: {
    fontSize: 20,
    marginLeft: 5,
    fontWeight: 500,
    cursor: 'default',
    width: '12rem',
    overflow: 'hidden',
    transition: 'background-color 0.2s',
    '& input': {
      width: '100%',
      paddingInline: '4px',
      borderColor: theme.grey3
    }
  },
  canUpdateInput: {
    '&:hover': {
      backgroundColor: theme.grey8
    }
  }
});
